import { render, staticRenderFns } from "./word-cloud.vue?vue&type=template&id=2b3c2635&scoped=true&"
import script from "./word-cloud.vue?vue&type=script&lang=js&"
export * from "./word-cloud.vue?vue&type=script&lang=js&"
import style0 from "./word-cloud.vue?vue&type=style&index=0&id=2b3c2635&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3c2635",
  null
  
)

component.options.__file = "word-cloud.vue"
export default component.exports